import {ApiError, ApiService} from "@/services/api.service";
import {Constants} from "@/constants";

const GOSservice = {

    /**
     * Function that makes backend call to "manually" assign an arrivalDate for a booking
     * in order to allow warehouse managers to move bookings from either delayed or expected to
     * arrived in the arrivals menu
     * @param booking
     * @returns {Promise<AxiosResponse<any>>}
     */
    setArrivalDate: async function (booking) {
        try {
            const endpoint = `${Constants.ENDPOINT_GOS}/${booking.id}`
            //create date object with current time and format it for the backend
            let arrivalDate = new Date().toISOString()
            let payload = {
                "vehicleArrivalDate" : arrivalDate,
                "vehicleDepartureDate" : null,
                "locationId": booking.location.id
            }
            const response = await ApiService.post(endpoint, payload)
            return response
        } catch(error) {
            throw new ApiError(error)
        }
    },

    /**
     * Function that makes backend call to "manually" assign a departureDate for a booking
     * in order to allow warehouse managers to move bookings out of arrived in the arrivals screen
     * @param booking
     * @returns {Promise<AxiosResponse<any>>}
     */
    setDepartureDate: async function (booking) {
        try {
            //create date object with current time and format it for the backend
            let departureDate = new Date().toISOString()
            let payload = {
                "vehicleArrivalDate" : booking.vehicleArrivalDate,
                "vehicleDepartureDate" : departureDate,
                "locationId": booking.location.id
            }
            const response = await ApiService.post(endpoint, payload)
            return response
        } catch(error) {
            throw new ApiError(error)
        }
    },

    updateGOSBooking: async function (booking) {
        try {
            const endpoint = `${Constants.ENDPOINT_GOS}/${booking.id}`
            const payload = {
                "vehicleArrivalDate" : booking.vehicleArrivalDate,
                "vehicleDepartureDate" : booking.vehicleDepartureDate,
                "dockArrivalDate" : booking.dockArrivalDate,
                "dockDepartureDate" : booking.dockDepartureDate,
                "startHandlingDate" : booking.startHandlingDate,
                "stopHandlingDate" : booking.stopHandlingDate,
                "locationId": booking.location.id
            }
            return await ApiService.post(endpoint, payload)
        } catch(error) {
            throw new ApiError(error)
        }

    }


}

export {GOSservice}
